import { ETag } from '../../repositories/newbuilding-reviews/entities/get_reviews_web/GetReviewsWebRequest';
import { ETagType, ITag } from '../../types/tag';

const mapper = {
  [ETagType.Adjoining_territory]: ETag.Adjoining_territory,
  [ETagType.Construction]: ETag.Construction,
  [ETagType.Developer]: ETag.Developer,
  [ETagType.District]: ETag.District,
  [ETagType.Flat]: ETag.Flat,
  [ETagType.House]: ETag.House,
  [ETagType.Infrastructure]: ETag.Infrastructure,
  [ETagType.Kids]: ETag.Kids,
  [ETagType.Management_company]: ETag.Management_company,
  [ETagType.Parking]: ETag.Parking,
  [ETagType.Purchase]: ETag.Purchase,
  [ETagType.Transport_affordable]: ETag.Transport_affordable,
};

export const prepareTagsFiltersRequest = (tag: ITag | null | undefined): ETag | null => {
  return tag ? mapper[tag.type] : null;
};
